<h2 mat-dialog-title>{{category_id? 'Update Ticket' : 'Add Ticket'}}</h2>
<form [formGroup]="ScanningForm" (ngSubmit)="onFormSubmit()">
    <mat-dialog-content class="content">

        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Category</mat-label>
                <input [ngModel]="category" formControlName="category" matInput placeholder="Enter Category">
            </mat-form-field>
        </div>

        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Price</mat-label>
                <input type="number" [ngModel]="total_amount" formControlName="total_amount" matInput
                    placeholder="Enter Price">
            </mat-form-field>
        </div>

        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Max Allowed</mat-label>
                <input matInput type="number" formControlName="max_allowed" [ngModel]="max_allowed" min="1">
                <mat-hint align="start">
                    <strong>Maximum buying quantity allowed</strong>
                </mat-hint>
                <mat-error *ngIf="ScanningForm.get('max_allowed')?.invalid">
                    Minimum 1 person required
                </mat-error>
            </mat-form-field>
        </div>

        <br>

        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Color</mat-label>
                <input [ngModel]="color" formControlName="color" matInput placeholder="eg. #FFF">
            </mat-form-field>
        </div>

        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>No Of Tickets</mat-label>
                <input type="number" [ngModel]="total_category_tickets" formControlName="total_category_tickets"
                    matInput placeholder="Enter Total Tickets">
            </mat-form-field>
        </div>

        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Auto Assign</mat-label>
                <mat-select [ngModel]="auto_assign" formControlName="auto_assign">
                    <mat-option value="yes">Yes</mat-option>
                    <mat-option value="no">No</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

    </mat-dialog-content>
    <mat-dialog-actions class="action" align="end">
        <button mat-raised-button type="button" color="warn" [mat-dialog-close]="false">Cancel</button>
        <button mat-raised-button type="submit" color="primary">{{category_id? 'Update' : 'Add'}}</button>
    </mat-dialog-actions>
</form>